import React from 'react';
import { Check, X } from 'lucide-react';
export function AudienceSection() {
  const isFor = ['Mujeres latinas en USA que sueñan con comprar su primera casa este año.', 'Madres que quieren estabilidad y un patio propio para sus hijos.', 'Emprendedoras que necesitan un mejor crédito para hacer crecer su negocio.', 'Cualquier mujer cansada de pagar intereses abusivos en su auto o tarjetas.'];
  const isNotFor = ['Personas que buscan trucos ilegales o "borrar" deudas legítimas que no piensan pagar.', 'Quien no esté dispuesta a caminar 10 minutos hasta el correo para enviar una carta.', 'Aquellas que esperan resultados de la noche a la mañana sin seguir el proceso de 90 días.'];
  return <section className="bg-white py-16 md:py-24 px-4" data-id="element-1">
      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-2">
        {/* Who this is for */}
        <div className="bg-brand-navy text-white p-8 md:p-12 rounded-3xl shadow-xl" data-id="element-3">
          <h3 className="font-heading text-3xl font-bold mb-8 text-brand-gold" data-id="element-4">
            Esto ES para ti si:
          </h3>
          <ul className="space-y-6" data-id="element-5">
            {isFor.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-6">
                <div className="bg-green-500/20 p-1 rounded-full mt-1" data-id="element-7">
                  <Check className="w-5 h-5 text-green-400" data-id="element-8" />
                </div>
                <span className="font-body text-lg text-gray-200" data-id="element-9">{item}</span>
              </li>)}
          </ul>
        </div>

        {/* Who this is not for */}
        <div className="bg-gray-50 border border-gray-200 p-8 md:p-12 rounded-3xl" data-id="element-10">
          <h3 className="font-heading text-3xl font-bold mb-8 text-gray-800" data-id="element-11">
            Esto NO es para ti si:
          </h3>
          <ul className="space-y-6" data-id="element-12">
            {isNotFor.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-13">
                <div className="bg-red-100 p-1 rounded-full mt-1" data-id="element-14">
                  <X className="w-5 h-5 text-red-500" data-id="element-15" />
                </div>
                <span className="font-body text-lg text-gray-700" data-id="element-16">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}